import { render, staticRenderFns } from "./FollowUpIsland.vue?vue&type=template&id=592a1009&scoped=true"
import script from "./FollowUpIsland.vue?vue&type=script&lang=js"
export * from "./FollowUpIsland.vue?vue&type=script&lang=js"
import style0 from "./FollowUpIsland.vue?vue&type=style&index=0&id=592a1009&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592a1009",
  null
  
)

export default component.exports